import styled from 'styled-components';
import { Button, Space } from 'antd';

export const StyledSpace = styled(Space)`
  && {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    
    // 确保事件不会冒泡到父元素
    pointer-events: auto;
    position: relative;
    z-index: 1;
  }
`;

export const OperationButton = styled(Button)`
  && {
    padding: 4px;
    height: auto;
    line-height: 1;
    
    &:hover {
      background-color: rgba(255, 255, 255, 0.08);
    }
    
    &:active {
      background-color: rgba(255, 255, 255, 0.12);
    }
  }
`;